import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Title } from '../style';
import { Settings } from './settings';
import CustomCarousel from '../../CustomCarousel';

const Media = styled.div`
  background: url(${({ src }) => src});
  max-width: 90%;
  height: 200px;
  margin: 0 auto;
  background-position: center;
  background-size: cover;
  display: block !important;
`;

// eslint-disable-next-line arrow-body-style
const MediaCarousel = ({ data, title }) => {
  return (
    <>
      <Title>{title}</Title>
      {data && (
        <CustomCarousel config={Settings}>
          {(data || []).map((img, index) => (
            <Media src={img.src} alt={img?.alt} key={`img-${index}`} />
          ))}
        </CustomCarousel>
      )}
    </>
  );
};

MediaCarousel.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
};

export default MediaCarousel;
